import React from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { Table, TableContainer, TableHeader, TableHeaderRow, TableHeaderColumn, TableBody, TableRow, TableColumn, Dialog, DialogTitle,
    DialogContent, FlexRow, NotFound, ButtonGroup, CircularButton } from './Styles/MappedUsersDialogBox';

const DSOSettingsDialogBox = ({ open = false, id = '', onClose = null, data, ...props }) => {
	return (
		<Dialog
			maxWidth='md'
			fullWidth
			open={open}
			onClose={() => onClose()}
		>
			<DialogTitle>
                Mapped Users
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						onClick={() => onClose()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent style={{ padding: '0px' }}>
				<TableContainer
					height='auto'
					width='540px'
				>
					<Table>
						<TableHeader>
							<TableHeaderRow>
								<TableHeaderColumn style={{ width: '22%' }}>Clinic Name</TableHeaderColumn>

								<TableHeaderColumn style={{ width: '22%' }}>Group Name</TableHeaderColumn>

								<TableHeaderColumn style={{ width: '22%' }}>User Name</TableHeaderColumn>

								<TableHeaderColumn style={{ width: '34%' }}>Email</TableHeaderColumn>
							</TableHeaderRow>
						</TableHeader>

						<TableBody>
							{data && data.length ? (
								data.map((item, index) => (
									<TableRow key={index}>
										<TableColumn>
											<FlexRow>{item.clinic_name || 'No Name'}</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>{item.group_name || 'No Group'}</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>{item.fname || 'No Name'}</FlexRow>
										</TableColumn>

										<TableColumn>
											<FlexRow>{item.email || 'No Email'}</FlexRow>
										</TableColumn>
									</TableRow>
								))
							) : (
								<TableRow key='not-found'>
									<TableColumn colSpan={'100%'}>
										<NotFound line1="Couldn't find any users." />
									</TableColumn>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</DialogContent>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {};

export default connect(mapStatesToProps, mapFunctionsToProps)(DSOSettingsDialogBox);
